import axios from "axios";
import queryString from "query-string";
const ENDPOINT_PATH = "/elsa/openapi";
const host = `https://apps.optanium.com${ENDPOINT_PATH}`;

function paramsSerializer(params: any) {
  return queryString.stringify(params);
}

const API = axios.create({
  baseURL: host,
  paramsSerializer,
  headers: {
    apiKey: "93362b2e5a8aadf062dfd61b82586001",
  },
});

export const getQuestionnaireData = async () => {
  try {
    const res = await API.get("/sp_questionnaire");
    return res.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getSectionData = async (questionnaire_id: number) => {
  try {
    const res = await API.get(
      `/sp_sections?questionnaire_id=${questionnaire_id}`
    );
    return res.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getQuestionsData = async (section_id: number) => {
  try {
    const res = await API.get(`/sp_questions?section_id=${section_id}`);
    return res.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getOptionsData = async (question_id: number) => {
  try {
    const res = await API.get(`/sp_options?question_id=${question_id}`);
    return res.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const submitAnswers = async (payload: any) => {
  return API.post("/sp_answers", payload);
};
